import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import * as XLSX from "xlsx";
import { Fetchexecutequery } from "../../../services/process/BRS1/brsService7";

const FileFormatMapper = () => {
  const [sources, setSources] = useState([]);
  const [selectedSource, setSelectedSource] = useState(null);
  const [sourceColumns, setSourceColumns] = useState([]);
  const [file, setFile] = useState(null);
  const [startingRow, setStartingRow] = useState(1);
  const [fileColumns, setFileColumns] = useState([]);
  const [columnMappings, setColumnMappings] = useState({});
  const [allFileColumns, setAllFileColumns] = useState([]);

  const [divisions, setDivisions] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [vendors, setVendors] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);

  useEffect(() => {
    fetchSources();
    fetchDivisions();
  }, []);

  const fetchDivisions = async () => {
    const query = "SELECT DISTINCT division FROM vendor_recon.vendor_master";
    fetchtabledetailsInfo(query, setDivisions, "no");
  };

  const handleDivisionSelect = async (selected) => {
    setSelectedDivision(selected);
    const query = `SELECT DISTINCT vendor_name, vendor_code, contact_email FROM vendor_recon.vendor_master WHERE division = '${selected.division || selected.label}'`;
    fetchtabledetailsInfo(query, (data) => {
      const formatted = data.map(v => ({
        label: `${v.vendor_name} (${v.vendor_code})`,
        value: v.vendor_code,
        name: v.vendor_name,
        email: v.contact_email || ""
      }));
      setVendors(formatted);
    }, "no");
    setSelectedVendors([]);
  };

  const handleVendorSelect = (selectedOptions) => {
    const newSelections = selectedOptions.filter(v => !selectedVendors.find(sv => sv.value === v.value));
    setSelectedVendors([...selectedVendors, ...newSelections]);
  };

  const updateVendorEmail = (vendorCode, newEmail) => {
    setSelectedVendors(prev =>
      prev.map(v => v.value === vendorCode ? { ...v, email: newEmail } : v)
    );
  };

  const removeVendor = (vendorCode) => {
    setSelectedVendors(prev => prev.filter(v => v.value !== vendorCode));
  };

  const fetchSources = async () => {
    const query = "SELECT source_name, source_id FROM process_data.source_master WHERE is_active = 1";
    fetchtabledetailsInfo(query, setSources);
  };

  const fetchtabledetailsInfo = async (query, setField, status = "yes") => {
    const payload = { query };
    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      const data = response.data;

      if (data && data.length > 0) {
        if (status === "no") {
          setField(data);
        } else {
          const keys = Object.keys(data[0]);
          const labelKey = keys.find((k) => k.toLowerCase().includes("name"));
          const valueKey = keys.find((k) => k.toLowerCase().includes("_id"));

          const formatted = data.map((item) => ({
            label: item[labelKey],
            value: item[valueKey],
            description: item.description || "-",
            ...item
          }));
          setField(formatted);
        }
      } else {
        setField([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setField([]);
    }
  };


  const handleCreate = () => {
        window.location.reload();
  };




  const handleSourceSelect = async (selected) => {
    setSelectedSource(selected);
    setSourceColumns([]);
    setColumnMappings({});

    const query = `SELECT columns FROM process_data.source_master WHERE source_id = ${selected.value};`;
    const FileUploadCredentials = Fetchexecutequery();

    try {
      const response = await axios.post(FileUploadCredentials[1], { query }, FileUploadCredentials[0]);
      const result = response.data;
      if (result && result.length > 0 && result[0].columns) {
        const columnJson = JSON.parse(result[0].columns);

        if (Array.isArray(columnJson) && columnJson[0]?.column_names) {
          const mapped = columnJson[0].column_names.map((col) => ({
            label: col,
            value: col
          }));
          setSourceColumns(mapped);
        }
      }
    } catch (err) {
      console.error("Error fetching source columns:", err);
    }
  };

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile) {
      setFile(uploadedFile);
      setFileColumns([]);
      setColumnMappings({});
    }
  };

  const parseFile = () => {
    if (!file || startingRow < 1) {
      alert("Please upload a file and enter a valid starting row.");
      return;
    }

    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const jsonData = XLSX.utils.sheet_to_json(ws, { header: 1 });

      const headers = jsonData[Number(startingRow) - 1];
      if (Array.isArray(headers)) {
        const colOptions = headers.map((col, idx) => ({
          label: col || `Column ${idx + 1}`,
          value: col || `Column ${idx + 1}`,
        }));
        setFileColumns(colOptions);
        setAllFileColumns(colOptions);
      } else {
        alert("No header row found at the selected row.");
      }
    };
    reader.readAsBinaryString(file);
  };

  const handleMappingChange = (sourceCol, fileCol) => {
    setColumnMappings((prev) => ({ ...prev, [sourceCol]: fileCol }));
  };

  const filteredVendorOptions = vendors.filter(
    (v) => !selectedVendors.find((sv) => sv.value === v.value)
  );




  return (
    <div style={{ padding: 20 }}>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: '18px' }}>Vendor Statement Mapping</h2>


      <div style={{ display: "flex", gap: 20, marginBottom: 20 }}>
        <div>
          <label>Division</label>
          <Select
            options={divisions.map((d) => ({ label: d.division, value: d.division, ...d }))}
            value={selectedDivision}
            onChange={handleDivisionSelect}
            placeholder="Select Division"
          />
        </div>
        <div>
          <label>Source Name</label>
          <Select
            options={sources}
            value={selectedSource}
            onChange={handleSourceSelect}
            placeholder="Select Source"
          />
        </div>
        <div>
          <label>Upload File</label><br />
          <input type="file" accept=".xlsx,.xls" onChange={handleFileChange} />
        </div>
        <div>
          <label>Starting Row</label><br />
          <input
            type="number"
            min={1}
            value={startingRow}
            onChange={(e) => setStartingRow(Number(e.target.value))}
            style={{ width: "100%" }}
          />
        </div>
        <div style={{ alignSelf: "flex-end" }}>
          <button
            onClick={parseFile}
            style={{ backgroundColor: "#000055", color: "#fff", padding: "6px 12px", borderRadius: 4 }}
          >
            Parse File
          </button>
        </div>
        <div style={{ alignSelf: "flex-end" }}>
          <button
            onClick={handleCreate }
            style={{ backgroundColor: "#000055", color: "#fff", padding: "6px 12px", borderRadius: 4 }}
          >
            Save
          </button>
        </div>

      </div>

      <div style={{ display: "flex", gap: 30 }}>
        <div>
      <div>

          <label>Select Vendors</label>
          <Select
            isMulti
            options={filteredVendorOptions}
            onChange={handleVendorSelect}
            placeholder="Select Vendors"
            value={null}
            menuPlacement="auto"
            maxMenuHeight={150}
          />
      </div>
          <div style={{ marginTop: 10, border: "1px solid #ccc", borderRadius: 4, padding: 8, background: "#ffffff" }}>
            {selectedVendors.map((v, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 6,
                  color: "#000000"
                }}
              >
                <span style={{ minWidth: 200 }}>{v.name} ({v.value})</span>
                <input
                  type="email"
                  value={v.email || ""}
                  placeholder="Enter contact email"
                  onChange={(e) => updateVendorEmail(v.value, e.target.value)}
                  style={{
                    padding: 2,
                    borderRadius: 4,
                    border: "1px solid #ccc",
                    flex: 1,
                    color: "#000000"
                  }}
                />
                <button
                  onClick={() => removeVendor(v.value)}
                  style={{
                    background: "#ff4d4d",
                    border: "none",
                    borderRadius: 4,
                    color: "#ffffff",
                    padding: "4px 8px",
                    cursor: "pointer"
                  }}
                >
                  x
                </button>
              </div>
            ))}
          </div>
        </div>

        <div>
          {sourceColumns.length > 0 && fileColumns.length > 0 && (
            <div>
              <h3>Column Mapping</h3>
              <div style={{ display: "flex", fontWeight: "bold", marginBottom: 10 }}>
                <div style={{ width:'190px',marginRight:'40px' }}>Source Column</div>
                <div style={{ width:'190px' }}>File Column</div>
              </div>
              {sourceColumns.map((srcCol, idx) => {
                const selectedFileCols = Object.entries(columnMappings)
                  .filter(([key]) => key !== srcCol.value)
                  .map(([_, val]) => val);
                const availableOptions = [
                  { label: "Ignore", value: "__ignore__" },
                  ...allFileColumns.filter(
                    (col) => !selectedFileCols.includes(col.value) || col.value === columnMappings[srcCol.value]
                  )
                ];
                return (
                  <div key={idx} style={{ marginBottom: 12, display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        flex: 1,
                        padding: "6px 12px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: 4,
                        border: "1px solid #ccc",
                      }}
                    >
                      {srcCol.label}
                    </div>
                    <div style={{ flex: 2, marginLeft: 10 }}>
                      <Select
                        options={availableOptions}
                        value={
                          columnMappings[srcCol.value] === "__ignore__"
                            ? { label: "Ignore", value: "__ignore__" }
                            : allFileColumns.find((c) => c.value === columnMappings[srcCol.value]) || null
                        }
                        onChange={(e) => handleMappingChange(srcCol.value, e.value)}
                        placeholder="Map to file column..."
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileFormatMapper;
